(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juti-coffee-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-juti-finder]').forEach((root) => {
    const steps = [...root.querySelectorAll('[data-step]')];
    const next = root.querySelector('[data-next]');
    const back = root.querySelector('[data-back]');
    const restart = root.querySelector('[data-restart]');
    const results = root.querySelector('[data-results]');
    const grid = root.querySelector('[data-result-grid]');
    const shell = root.querySelector('.juti-finder-page__shell');
    const progressBar = root.querySelector('[data-progress-bar]');
    const progressText = root.querySelector('[data-progress-text]');
    const products = [...root.querySelectorAll('.juti-finder-product')];
    const answers = {};
    let stepIndex = 0;

    const strengthBucket = (value) => {
      const number = Number(value || 3);
      if (number <= 2) return 'mild';
      if (number === 3) return 'round';
      return 'strong';
    };

    const updateStep = () => {
      steps.forEach((step, index) => {
        const active = index === stepIndex;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });
      const current = steps[stepIndex];
      next.disabled = !answers[current.dataset.key];
      back.hidden = stepIndex === 0;
      next.textContent = stepIndex === steps.length - 1 ? root.dataset.resultLabel : root.dataset.nextLabel;
      progressBar.style.width = `${((stepIndex + 1) / steps.length) * 100}%`;
      progressText.textContent = `${stepIndex + 1} / ${steps.length}`;
    };

    steps.forEach((step) => {
      step.querySelectorAll('[data-answer]').forEach((button) => {
        button.addEventListener('click', () => {
          step.querySelectorAll('[data-answer]').forEach((candidate) => candidate.classList.remove('is-selected'));
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          answers[step.dataset.key] = button.dataset.answer;
          next.disabled = false;

          window.setTimeout(() => {
            if (stepIndex === steps.length - 1) {
              renderResults();
              return;
            }
            stepIndex += 1;
            updateStep();
          }, 120);
        });
      });
    });

    const scoreProduct = (product) => {
      const brew = product.dataset.brew.split('||');
      const flavors = product.dataset.flavors.split('||');
      const isDecaf = product.dataset.decaf === 'true';

      if (answers.caffeine === 'decaf' && !isDecaf) return -999;
      if (answers.caffeine === 'yes' && isDecaf) return -999;

      let score = 3;
      if (brew.includes(answers.brew)) score += 6;
      if (strengthBucket(product.dataset.strength) === answers.strength) score += 3;
      if (flavors.includes(answers.flavor)) score += 3;
      return score;
    };

    const renderResults = () => {
      const ranked = products
        .map((product) => ({ product, score: scoreProduct(product) }))
        .filter((item) => item.score > -999)
        .sort((a, b) => b.score - a.score)
        .slice(0, 3);

      grid.innerHTML = '';
      ranked.forEach((item, index) => {
        const card = item.product.cloneNode(true);
        card.hidden = false;
        const rank = card.querySelector('.juti-finder-product__rank');
        rank.textContent = index === 0 ? root.dataset.bestLabel : root.dataset.altLabel;
        grid.appendChild(card);
      });

      shell.hidden = true;
      results.hidden = false;
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    next.addEventListener('click', () => {
      if (next.disabled) return;
      if (stepIndex === steps.length - 1) {
        renderResults();
        return;
      }
      stepIndex += 1;
      updateStep();
    });

    back.addEventListener('click', () => {
      if (stepIndex === 0) return;
      stepIndex -= 1;
      updateStep();
    });

    restart.addEventListener('click', () => {
      Object.keys(answers).forEach((key) => delete answers[key]);
      steps.forEach((step) => step.querySelectorAll('[data-answer]').forEach((button) => {
        button.classList.remove('is-selected');
        button.removeAttribute('aria-pressed');
      }));
      stepIndex = 0;
      results.hidden = true;
      shell.hidden = false;
      updateStep();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    updateStep();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
